import WorkplacePage from './views/Workplace';

export const workplaceRoutes = [
  {
    path: 'workplace',
    name: '工作台',
    icon: 'desktop',
    hideInMenu: true,
    element: <WorkplacePage />,
  },
];
